import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import VideoEditOrderCheck, { VideoEditOrderCheckProps } from './VideoEditOrderCheck';
import { selectRelativeUser } from '../../store/modules/users/selectors';
import { selectProject } from '../../store/modules/projects/selectors';
import { getUserRequest } from '../../store/modules/users/actions';

type Props = Pick<VideoEditOrderCheckProps, 'inModal'>;

const VideoEditOrderCheckForm = ({ inModal }: Props) => {
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const ownerId = project.data?.user_owner_id || 0;
  const { data: user } = useSelector(selectRelativeUser);
  const { watch } = useFormContext();
  const videoDuration = watch('options.video_duration_key');
  const firstEditId = watch('first_edit_delivery_id');
  const videoDurationMin = watch('options.additional_min');
  const additionalMinutes = videoDuration === 3 ? videoDurationMin - 5 : 0;
  const creditsRemaining = user?.ref?.active_subscription?.video_credits_balance || 0;
  const firstEditTitle = firstEditId === 'overnight' ? 'Overnight' : 'Same-day';
  const firstEditPrice = firstEditId === 'overnight' ? 0 : 50;
  const totalPrice = additionalMinutes * 10 + firstEditPrice;

  const plan = user?.ref.plan;
  const userHavePlan = !!user && plan === 'subscription-pay-as-you-go';

  useEffect(() => {
    if (ownerId) {
      dispatch(getUserRequest(ownerId));
    }
  }, [ownerId, dispatch]);

  return (
    <VideoEditOrderCheck
      additionalMinutes={additionalMinutes}
      creditsRemaining={creditsRemaining}
      firstEditTitle={firstEditTitle}
      firstEditPrice={firstEditPrice}
      totalPrice={totalPrice}
      isPlan={userHavePlan}
      inModal={inModal}
    />
  );
};

export default VideoEditOrderCheckForm;
